<template lang="pug">
w-input.w-select(
  :class=`{ focus: isFocused, disabled }`
  v-bind=`{ value, label, required, disabled }` @input='input'
)
  template( #default=`{ inputType, value, listeners }`)
    vue-multiselect.input(
      v-bind=`{
        placeholder,
        tagPlaceholder,
        value,
        options,
        trackBy, 
        disabled,
      }`
      :class=`{ inline: inModal }`
      :multiple='!single'
      :close-on-select='single'
      :clear-on-select='single'
      :taggable='$listeners.add'
      :label='optionLabel'
      :block-keys=`[ 'Tab', 'Enter' ]`
      :custom-label='customLabel || thisCustomLabel'
      v-on='listeners'
      @tag='add'
      @open='open'
      @close='close'
    )
      template( v-if="$scopedSlots.singleLabel" #singleLabel='{ option }')
        slot( name='singleLabel' v-bind='option' )
      template( #option='{ option }' )
        slot( name='option' v-bind='option')
          .title( v-html=`option[ optionTitle ]` )
          .description(
            v-if='optionDescription'
            v-html=`option[ optionDescription ]`
          )
</template>

<script lang="js">
import { mapState, mapActions } from 'vuex'
import VueMultiselect from 'vue-multiselect'
import WInput, { mixin } from './w-input'

export default {
  name: 'SelectWidget',
  mixins: [ mixin ],
  components: { WInput, VueMultiselect },
  props: {
    label: {
      type: String,
      default: 'Select'
    },
    value: {
      type: [ Number, String, Object, Array ],
      default: () => []
    },
    options: {
      type: [ Array ],
      default: () => []
    },
    placeholder: {
      type: String,
      default: ' '
    },
    single: Boolean,
    readonly: Boolean,
    trackBy: {
      type: String,
      default: 'id'
    },
    optionLabel: {
      type: String,
      default: 'name'
    },
    optionTitle: {
      type: String,
      default: 'name'
    },
    optionDescription: {
      type: String,
      default: 'description'
    },
    tagPlaceholder: {
      type: String,
      default: 'Add a new item'
    },
    customLabel: Function,
  },
  inject: {
    inModal: {
      default: false
    }
  },
  data() {
    return {
      isFocused: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    thisCustomLabel( option ) {
      return this.optionDescription ? `${ 
        option[ this.optionLabel ]
      } - ${
        option[ this.optionDescription ]
      }` : option[ this.optionLabel ]
    },
    add( $event ) {
      this.$emit( 'add', $event )
    },
    open() {
      this.isFocused = true
      this.$emit( 'focus' )
    },
    close() {
      this.isFocused = false
      this.$emit( 'blur' )
    }
  },
  computed: {}
}
</script>

<style lang="scss">
.w-select {
  .input-wrapper {
    .input {
      height: auto;
      min-height: var(--h-input, 2rem);
    }
  }
  .multiselect {
    &__tags {
      background: transparent;
      border: 0 none;
    }
    &__tag {
      &, & * {
        background: var(--c-fg);
        color: var(--c-bg);
      }
    }
    &.inline .multiselect__content-wrapper {
      position: relative;
      max-height: unset !important;
      border: 0 none;
      border-radius: 0;
    }
    &__option {
      .title {
        font-size: 110%;
      }
      .description {
        font-size: 90%;
        line-height: 1.25rem;
        color: grey;
      }
      &--highlight {
        .description {
          color: rgba(255,255,255,0.75);
        }
        &::after {
          content: unset;
        }
      }
    }
  }
  &.disabled {
    opacity: 0.5;
    &, label, .label {
      text-shadow: 0 1px 1px white;
      color: transparent;
      background-clip: text;
      background-color: rgba(0,0,0,0.5);
    }
  }
}
</style>
